import { render, staticRenderFns } from "./AppModuleRight.vue?vue&type=template&id=06fada92&scoped=true&"
import script from "./AppModuleRight.vue?vue&type=script&lang=js&"
export * from "./AppModuleRight.vue?vue&type=script&lang=js&"
import style0 from "./AppModuleRight.vue?vue&type=style&index=0&id=06fada92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fada92",
  null
  
)

export default component.exports